import script from "./AppToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppToolbar.vue?vue&type=script&setup=true&lang=js"

import "./AppToolbar.vue?vue&type=style&index=0&id=64a81d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a81d5c"]])

export default __exports__